module.exports = __webpack_public_path__ + "img/service-map.3e4157c5.png";